import styled from "styled-components";

export const InfoForm = styled.div`
    .MuiInputBase-root{
        padding-top: 0;
        padding-bottom: 0;
    }
`;
